import { c as _c } from "react/compiler-runtime";
import Svg, { type SvgProps } from '../../Svg';

/**
 * Light Bulb Icon (12px) from Figma
 * @link [Figma](https://www.figma.com/design/OcHNCErLKZZwfVXAoIoRas/%F0%9F%8F%A6-Bank-Reconciliation?node-id=9187-21789&m=dev)
 * */
const LightBulbIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M4.78571 11.5H6.21429M5.5 1.21429V0.5M9.78571 4.78571H10.5M0.5 5.5H1.21429M8.53048 8.17333L9.03571 8.67857M1.96429 1.60714L2.46952 2.11238M8.53048 2.11238L9.03571 1.60714M1.96429 8.67857L2.46952 8.17333M8.35714 5.5C8.35906 4.96519 8.21082 4.44058 7.92931 3.98585C7.6478 3.53112 7.2443 3.16453 6.76474 2.9278C6.28517 2.69106 5.74879 2.59368 5.21661 2.64673C4.68443 2.69978 4.17783 2.90113 3.75443 3.22788C3.33104 3.55463 3.00785 3.99365 2.82165 4.495C2.63544 4.99635 2.59368 5.53991 2.70114 6.06382C2.80859 6.58773 3.06093 7.07096 3.42945 7.45854C3.79797 7.84612 4.26788 8.12248 4.78571 8.25619V9.58705H6.21429V8.25619C6.82646 8.09931 7.36915 7.74345 7.75704 7.24453C8.14492 6.74562 8.35602 6.13196 8.35714 5.5Z" className="stroke-current" strokeLinecap="round" strokeLinejoin="round" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Svg width={12} height={12} viewBox="0 0 11 12" {...props}>{t0}</Svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default LightBulbIcon;